// Category picker for admin forms. Empty value = no category.
export const CategorySelect = ({ id, value, onChange, categories, className = '', ...rest }) => (
  <select
    id={id}
    value={value || ''}
    onChange={(e) => onChange(e.target.value || null)}
    className={`h-10 w-full rounded-lg border border-border bg-input px-3 text-sm text-foreground ${className}`}
    {...rest}
  >
    <option value="">— No category —</option>
    {categories.map((c) => (
      <option key={c.category_id} value={c.category_id}>
        {c.name}
      </option>
    ))}
  </select>
);
